import { RTN_LIM_INIT_SUCCESS, RTN_LIM_INIT_FAIL, RTN_LIM_INIT_LOADING } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {}
}

const getters = {

}

const mutations = {
  [RTN_LIM_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [RTN_LIM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [RTN_LIM_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async rtnLimManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.rtnLimManagement
    commit(RTN_LIM_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(RTN_LIM_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(RTN_LIM_INIT_FAIL, extractMessages(error))
      }
    } else {
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
